document.documentElement.classList.remove('no-js');

document.addEventListener('click', function (e) {
  document.querySelectorAll('details[data-dropdown]').forEach(function (menu) {
    if (!menu.contains(e.target)) menu.removeAttribute('open');
  });
});

document.querySelectorAll('details[data-dropdown]').forEach(function (menu) {
  menu.addEventListener('toggle', function () {
    if (menu.open) {
      document.querySelectorAll('details[data-dropdown][open]').forEach(function (other) {
        if (other !== menu && !other.contains(menu) && !menu.contains(other)) {
          other.removeAttribute('open');
        }
      });
    }
  });
  menu.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function () { menu.removeAttribute('open'); });
  });
});

(function () {
  var header = document.querySelector('.site-header');
  if (!header) return;

  function update() {
    if (window.scrollY > 10) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  update();
  window.addEventListener('scroll', update, { passive: true });
})();

// Filtros de colección: aplican solos al tildar un checkbox
(function () {
  var filterForm = document.getElementById('CollectionFilters');
  if (!filterForm) return;
  filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
    cb.addEventListener('change', function () { filterForm.submit(); });
  });
})();

// Cerrar el menú móvil a pantalla completa con el botón X
document.querySelectorAll('[data-mobile-close]').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var menu = btn.closest('details[data-mobile-menu]');
    if (menu) menu.removeAttribute('open');
  });
});

// Panel de filtros en mobile: abre/cierra como hoja lateral
(function () {
  var sidebar = document.querySelector('[data-filter-sidebar]');
  var overlay = document.querySelector('.collection-page__sidebar-overlay');
  var openBtns = document.querySelectorAll('[data-open-filters]');
  var closeBtns = document.querySelectorAll('[data-close-filters]');
  if (!sidebar) return;

  function openFilters() {
    sidebar.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    sidebar.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openBtns.forEach(function (btn) { btn.addEventListener('click', openFilters); });
  closeBtns.forEach(function (btn) { btn.addEventListener('click', closeFilters); });
})();

// Buscador de productos dentro de la colección (filtra lo ya cargado en pantalla)
(function () {
  var input = document.querySelector('[data-collection-search]');
  var grid = document.querySelector('[data-product-grid]');
  var noResults = document.querySelector('[data-no-search-results]');
  if (!input || !grid) return;

  input.addEventListener('input', function () {
    var term = input.value.trim().toLowerCase();
    var cards = grid.querySelectorAll('.product-card');
    var visibleCount = 0;
    cards.forEach(function (card) {
      var title = card.querySelector('.product-card__title');
      var text = title ? title.textContent.toLowerCase() : '';
      var matches = term === '' || text.indexOf(term) !== -1;
      card.style.display = matches ? '' : 'none';
      if (matches) visibleCount++;
    });
    if (noResults) noResults.hidden = visibleCount !== 0 || term === '';
  });
})();

// Buscador con overlay centrado y sugerencias en vivo
(function () {
  var overlay = document.querySelector('[data-search-overlay]');
  if (!overlay) return;
  var input = overlay.querySelector('[data-search-input]');
  var clearBtn = overlay.querySelector('[data-search-clear]');
  var submitBtn = overlay.querySelector('[data-search-submit]');
  var closeBtn = overlay.querySelector('[data-search-close]');
  var resultsBox = overlay.querySelector('[data-search-results]');
  var suggestionsList = overlay.querySelector('[data-search-suggestions]');
  var suggestionsCol = overlay.querySelector('[data-search-suggestions-col]');
  var productsList = overlay.querySelector('[data-search-products]');
  var searchUrl = overlay.dataset.searchUrl || '/search';
  var debounceTimer;
  var currentFetchTerm = '';

  function clearResults() {
    if (suggestionsList) suggestionsList.innerHTML = '';
    if (productsList) productsList.innerHTML = '';
    if (resultsBox) resultsBox.classList.remove('is-visible');
    if (suggestionsCol) suggestionsCol.hidden = false;
  }

  function openOverlay() {
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 50);
  }
  function closeOverlay() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openOverlay();
    });
  });
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      input.focus();
      clearBtn.hidden = true;
      currentFetchTerm = '';
      clearResults();
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });

  function renderResults(data, term) {
    // Evita pintar resultados de una búsqueda vieja que llegó tarde (fuera de orden)
    if (term !== currentFetchTerm) return;

    var collections = (data && data.resources && data.resources.results.collections) || [];
    var products = (data && data.resources && data.resources.results.products) || [];

    if (suggestionsList) {
      suggestionsList.innerHTML = '';
      collections.slice(0, 8).forEach(function (col) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = col.url;
        a.textContent = col.title;
        li.appendChild(a);
        suggestionsList.appendChild(li);
      });
    }
    if (suggestionsCol) suggestionsCol.hidden = collections.length === 0;

    if (productsList) {
      productsList.innerHTML = '';
      products.slice(0, 10).forEach(function (p) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = p.url;
        a.className = 'search-overlay__product';

        var img = document.createElement('img');
        img.src = p.image || '';
        img.alt = p.title || '';

        var titleEl = document.createElement('span');
        titleEl.className = 'search-overlay__product-title';
        titleEl.textContent = p.title;

        a.appendChild(img);
        a.appendChild(titleEl);
        li.appendChild(a);
        productsList.appendChild(li);
      });
    }

    if (resultsBox) {
      var hasResults = collections.length > 0 || products.length > 0;
      resultsBox.classList.toggle('is-visible', hasResults);
    }
  }

  if (input) {
    input.addEventListener('input', function () {
      var term = input.value.trim();
      if (clearBtn) clearBtn.hidden = term === '';
      clearTimeout(debounceTimer);

      if (term.length < 2) {
        currentFetchTerm = '';
        clearResults();
        return;
      }

      debounceTimer = setTimeout(function () {
        currentFetchTerm = term;
        fetch('/search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=product,collection&resources[limit]=10&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) { renderResults(data, term); })
          .catch(function () { renderResults(null, term); });
      }, 250);
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var term = input.value.trim();
        if (term) window.location.href = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
      }
    });
  }
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      var term = input ? input.value.trim() : '';
      if (term) window.location.href = searchUrl + '?q=' + encodeURIComponent(term) + '&type=product';
    });
  }
})();

// Carrito lateral (drawer): abre con el ícono del header, se actualiza con AJAX
window.CVLCart = (function () {
  var drawer, itemsEl, emptyEl, subtotalEl, countEl, membershipMsgEl, membershipBarEl;
  var membershipGoal = 0;
  var membershipTemplate = '';
  var membershipComplete = '';

  function moneyFmt(cents) {
    try {
      return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toString();
    }
  }

  function init() {
    drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    itemsEl = drawer.querySelector('[data-cart-drawer-items]');
    emptyEl = drawer.querySelector('[data-cart-drawer-empty]');
    subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');
    countEl = drawer.querySelector('[data-cart-drawer-count]');
    membershipMsgEl = drawer.querySelector('[data-cart-membership-message]');
    membershipBarEl = drawer.querySelector('[data-cart-membership-bar]');
    membershipGoal = parseInt(drawer.dataset.membershipGoal, 10) || 25000000;
    membershipTemplate = drawer.dataset.membershipTemplate || '';
    membershipComplete = drawer.dataset.membershipComplete || '';

    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    drawer.querySelectorAll('[data-cart-drawer-checkout]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (window.CVLBuyFlow) {
          window.CVLBuyFlow.playFromCart();
        } else {
          window.location.href = '/checkout';
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    document.querySelectorAll('[data-cart-icon]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });

    fetchCart();
  }

  function render(cart) {
    if (!drawer) return;

    if (countEl) countEl.textContent = '\u2022 ' + cart.item_count;
    if (subtotalEl) subtotalEl.textContent = '$' + moneyFmt(cart.total_price) + ' CLP';

    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    if (emptyEl) emptyEl.style.display = cart.item_count === 0 ? '' : 'none';

    if (itemsEl) {
      itemsEl.style.display = cart.item_count === 0 ? 'none' : '';
      itemsEl.innerHTML = '';
      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'cart-drawer__item';

        var img = document.createElement('img');
        img.className = 'cart-drawer__item-img';
        img.src = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        img.alt = item.product_title || '';

        var info = document.createElement('div');
        info.className = 'cart-drawer__item-info';

        var titleEl = document.createElement('p');
        titleEl.className = 'cart-drawer__item-title';
        titleEl.textContent = item.product_title;
        info.appendChild(titleEl);

        if (item.variant_title && item.variant_title !== 'Default Title') {
          var varEl = document.createElement('p');
          varEl.className = 'cart-drawer__item-variant';
          varEl.textContent = item.variant_title;
          info.appendChild(varEl);
        }

        var qtyWrap = document.createElement('div');
        qtyWrap.className = 'cart-drawer__item-qty';
        var minusBtn = document.createElement('button');
        minusBtn.type = 'button';
        minusBtn.className = 'cart-drawer__qty-btn';
        minusBtn.textContent = '\u2212';
        minusBtn.addEventListener('click', function () {
          changeQty(item.key, Math.max(0, item.quantity - 1));
        });
        var qtySpan = document.createElement('span');
        qtySpan.textContent = item.quantity;
        var plusBtn = document.createElement('button');
        plusBtn.type = 'button';
        plusBtn.className = 'cart-drawer__qty-btn';
        plusBtn.textContent = '+';
        plusBtn.addEventListener('click', function () {
          changeQty(item.key, item.quantity + 1);
        });
        qtyWrap.appendChild(minusBtn);
        qtyWrap.appendChild(qtySpan);
        qtyWrap.appendChild(plusBtn);
        info.appendChild(qtyWrap);

        var right = document.createElement('div');
        right.className = 'cart-drawer__item-right';
        var priceEl = document.createElement('span');
        priceEl.className = 'cart-drawer__item-price';
        priceEl.textContent = '$' + moneyFmt(item.final_line_price);
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'cart-drawer__item-remove';
        removeBtn.innerHTML = '&times;';
        removeBtn.addEventListener('click', function () {
          changeQty(item.key, 0);
        });
        right.appendChild(priceEl);
        right.appendChild(removeBtn);

        li.appendChild(img);
        li.appendChild(info);
        li.appendChild(right);
        itemsEl.appendChild(li);
      });
    }

    if (membershipMsgEl && membershipGoal > 0) {
      var remaining = membershipGoal - cart.total_price;
      if (remaining > 0) {
        membershipMsgEl.textContent = membershipTemplate.replace('{{remaining}}', '$' + moneyFmt(remaining) + ' CLP');
      } else {
        membershipMsgEl.textContent = membershipComplete;
      }
    }
    if (membershipBarEl && membershipGoal > 0) {
      var pct = Math.min(100, Math.max(0, (cart.total_price / membershipGoal) * 100));
      membershipBarEl.style.width = pct + '%';
    }
  }

  function fetchCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        return cart;
      });
  }

  function changeQty(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function addItem(formData) {
    return fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () { return fetchCart(); })
      .then(function () {
        open();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { open: open, close: close, addItem: addItem, fetchCart: fetchCart };
})();

// Máquina de "imprimiendo pedido": global, usada por Comprar ahora (producto)
// y por PAGAR PEDIDO (carrito). Se conecta con el carrito real de Shopify.
// La boleta vive en una ventana de altura fija y se desliza con translateY
// desde adentro de la máquina — no depende de medir el contenido con JS,
// así que es robusto sin importar cuántos productos tenga la boleta.
window.CVLBuyFlow = (function () {
  var overlay, spinner, check, status, output, payBtn;
  var totalEl, total2El, subtotalEl, itemsEl, metaSkuEl, metaDateEl;
  var timers = [];
  var currentCart = null;
  var removedKeys = {};

  function moneyFmt(cents) {
    try {
      return new Intl.NumberFormat('es-CL', { maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toString();
    }
  }

  function init() {
    overlay = document.querySelector('[data-buy-flow-overlay]');
    if (!overlay) return;

    spinner = overlay.querySelector('[data-buy-flow-spinner]');
    check = overlay.querySelector('[data-buy-flow-check]');
    status = overlay.querySelector('[data-buy-flow-status]');
    output = overlay.querySelector('[data-buy-flow-output]');
    payBtn = overlay.querySelector('[data-buy-flow-pay]');
    totalEl = overlay.querySelector('[data-buy-flow-total]');
    total2El = overlay.querySelector('[data-buy-flow-total2]');
    subtotalEl = overlay.querySelector('[data-buy-flow-subtotal]');
    itemsEl = overlay.querySelector('[data-buy-flow-items]');
    metaSkuEl = overlay.querySelector('[data-buy-flow-meta-sku]');
    metaDateEl = overlay.querySelector('[data-buy-flow-meta-date]');

    overlay.querySelectorAll('[data-buy-flow-cancel]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });
    if (payBtn) {
      payBtn.addEventListener('click', function () {
        window.location.href = '/checkout';
      });
    }
  }

  function clearTimers() {
    timers.forEach(function (t) { clearTimeout(t); });
    timers = [];
  }

  // Vuelve todo al estado inicial: papel escondido, spinner visible,
  // botón de pagar oculto. Se usa antes de cada reproducción y al cerrar.
  function resetVisualState() {
    output.classList.remove('is-visible');
    payBtn.hidden = true;
    spinner.hidden = false;
    check.hidden = true;
    status.textContent = 'Imprimiendo tu pedido';
  }

  function close() {
    clearTimers();
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    resetVisualState();
  }

  function computeTotal() {
    var total = 0;
    (currentCart.items || []).forEach(function (item) {
      if (!removedKeys[item.key]) total += item.final_line_price;
    });
    return total;
  }

  function updateTotalsUI() {
    var total = computeTotal();
    totalEl.textContent = '$' + moneyFmt(total);
    total2El.textContent = '$' + moneyFmt(total);
    subtotalEl.textContent = '$' + moneyFmt(total);
  }

  // Cada línea de la boleta tiene una X roja para sacarla de la compra.
  // Al sacarla, se tacha con líneas (no desaparece) y el total se recalcula.
  function renderItems() {
    itemsEl.innerHTML = '';
    (currentCart.items || []).forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'buy-flow-paper__item';
      row.dataset.key = item.key;

      var main = document.createElement('div');
      main.className = 'buy-flow-paper__item-row';

      var name = document.createElement('span');
      name.textContent = item.quantity + 'x ' + item.product_title;
      var price = document.createElement('span');
      price.textContent = '$' + moneyFmt(item.final_line_price);
      main.appendChild(name);
      main.appendChild(price);
      row.appendChild(main);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('p');
        variant.className = 'buy-flow-paper__item-variant';
        variant.textContent = item.variant_title;
        row.appendChild(variant);
      }

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'buy-flow-paper__item-remove';
      removeBtn.innerHTML = '&times;';
      removeBtn.setAttribute('aria-label', 'Quitar ' + item.product_title);
      removeBtn.addEventListener('click', function () {
        removeItem(item.key, row);
      });
      row.appendChild(removeBtn);

      itemsEl.appendChild(row);
    });
    updateTotalsUI();
  }

  function removeItem(key, row) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentCart = cart;
        removedKeys[key] = true;
        row.classList.add('is-removed');
        updateTotalsUI();
        if (window.CVLCart) window.CVLCart.fetchCart();
      });
  }

  function populate() {
    metaSkuEl.textContent = '#' + Math.floor(1000 + Math.random() * 9000);
    metaDateEl.textContent = new Date().toLocaleDateString('es-CL', { day: '2-digit', month: 'short', year: 'numeric' });
    renderItems();
  }

  function playAnimation() {
    resetVisualState();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    // Paso 1: la boleta empieza a salir de adentro de la máquina, lento.
    // Solo togglea una clase — la transición la maneja el CSS (transform),
    // así que no hace falta medir el contenido con JavaScript.
    timers.push(setTimeout(function () {
      output.classList.add('is-visible');
    }, 500));

    // Paso 2: termina de salir, cambia a check verde
    timers.push(setTimeout(function () {
      spinner.hidden = true;
      check.hidden = false;
      status.textContent = 'BOLETA LISTA';
    }, 3900));

    // Paso 3: aparece el botón de pagar
    timers.push(setTimeout(function () {
      payBtn.hidden = false;
    }, 4300));
  }

  // Se usa desde "PAGAR PEDIDO" en el carrito: toma lo que ya hay en el carrito.
  function playFromCart() {
    if (!overlay) return;
    removedKeys = {};
    clearTimers();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentCart = cart;
        if (!cart.items.length) return;
        populate();
        playAnimation();
      });
  }

  // Se usa desde "Comprar ahora" en un producto: agrega el producto actual
  // Y muestra TODO el carrito (incluyendo lo que ya tenías antes).
  function playFromProduct(formData) {
    if (!overlay) return;
    removedKeys = {};
    clearTimers();
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        currentCart = cart;
        populate();
        playAnimation();
        if (window.CVLCart) window.CVLCart.fetchCart();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return { playFromCart: playFromCart, playFromProduct: playFromProduct, close: close };
})();

// Modal interstitial al hacer click en "Diggin" del menú del header
// (redirige a CVLTVRE MUSIC RECORDS, la tienda de vinilos)
(function () {
  var modal = document.querySelector('[data-diggin-modal]');
  if (!modal) return;

  var continueBtn = modal.querySelector('[data-diggin-continue]');
  var closeEls = modal.querySelectorAll('[data-diggin-close]');
  var pendingUrl = null;

  function openModal(url) {
    pendingUrl = url;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    pendingUrl = null;
  }

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  if (continueBtn) {
    continueBtn.addEventListener('click', function () {
      if (pendingUrl) window.location.href = pendingUrl;
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  // Intercepta, en fase de captura, cualquier click sobre un link del menú
  // del header (desktop o mobile) cuyo texto sea "Diggin"
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;

    var inHeaderNav = link.closest('.site-header__nav') || link.closest('.site-header__mobile-nav-list');
    if (!inHeaderNav) return;

    var label = (link.textContent || '').trim().toLowerCase();
    if (label.indexOf('diggin') === -1) return;

    e.preventDefault();
    openModal(link.href);
  }, true);
})();
